// Word list from TypeSloth - common English words for typing practice
const SIMPLE_WORD_BANK = [
  'the', 'be', 'to', 'of', 'and', 'in', 'that', 'have',
  'it', 'for', 'not', 'on', 'with', 'he', 'as', 'you', 'do', 'at',
  'this', 'but', 'his', 'by', 'from', 'they', 'we', 'say', 'her', 'she',
  'or', 'an', 'will', 'my', 'one', 'all', 'would', 'there', 'their', 'what',
  'so', 'up', 'out', 'if', 'about', 'who', 'get', 'which', 'go', 'me',
  'when', 'make', 'can', 'like', 'time', 'no', 'just', 'him', 'know', 'take',
  'people', 'into', 'year', 'your', 'good', 'some', 'could', 'them', 'see', 'other',
  'than', 'then', 'now', 'look', 'only', 'come', 'its', 'over', 'think', 'also',
  'back', 'after', 'use', 'two', 'how', 'our', 'work', 'first', 'well', 'way',
  'even', 'new', 'want', 'because', 'any', 'these', 'give', 'day', 'most', 'us',
  'great', 'between', 'need', 'large', 'under', 'never', 'each', 'right', 'hand', 'high',
  'place', 'small', 'found', 'part', 'long', 'still', 'last', 'own', 'light', 'left',
  'help', 'home', 'world', 'life', 'same', 'old', 'tell', 'much', 'before', 'head',
  'line', 'turn', 'move', 'live', 'find', 'here', 'thing', 'many', 'both', 'begin',
  'those', 'point', 'end', 'few', 'run', 'city', 'keep', 'seem', 'call', 'show',
  'every', 'house', 'number', 'side', 'water', 'night', 'open', 'change', 'play', 'must',
  'letter', 'being', 'answer', 'name', 'read', 'write', 'sound', 'more', 'word', 'set',
  'very', 'real', 'little', 'start', 'while', 'may', 'land', 'might', 'story', 'far',
  'near', 'hard', 'book', 'school', 'next', 'try', 'face', 'state', 'once', 'again',
  'learn', 'should', 'often', 'below', 'air', 'country', 'paper', 'group', 'always', 'music',
  'carry', 'food', 'stop', 'without', 'along', 'thought', 'kind', 'second', 'white', 'young',
  'leave', 'table', 'important', 'girl', 'idea', 'body', 'family', 'close', 'door', 'during',
  'early', 'form', 'away', 'problem', 'nothing', 'plant', 'follow', 'talk', 'room', 'until',
  'mark', 'watch', 'walk', 'together', 'question', 'father', 'mother', 'children', 'heart', 'earth',
  'cut', 'done', 'power', 'stand', 'across', 'bring', 'today', 'true', 'free', 'class',
  'possible', 'going', 'order', 'area', 'age', 'able', 'best', 'whole', 'sure', 'taken',
  // Short, easy everyday words (added to give Random Words more variety)
  'ask', 'add', 'ago', 'art', 'arm', 'bag', 'bad', 'bed', 'bet', 'big',
  'bit', 'box', 'boy', 'bus', 'buy', 'car', 'cat', 'cup', 'dad', 'dog',
  'dry', 'ear', 'eat', 'egg', 'eye', 'fan', 'fat', 'fit', 'fix', 'fly',
  'fun', 'gas', 'got', 'gun', 'hat', 'hot', 'ice', 'ill', 'job', 'joy',
  'key', 'kid', 'lay', 'leg', 'let', 'lie', 'lot', 'low', 'map', 'mix',
  'mom', 'net', 'nor', 'odd', 'off', 'oil', 'pay', 'pen', 'pet', 'pie',
  'put', 'raw', 'red', 'rid', 'row', 'sad', 'sat', 'sea', 'sit', 'six',
  'sky', 'son', 'sun', 'tax', 'tea', 'ten', 'tie', 'tip', 'toe', 'top',
  'toy', 'van', 'war', 'wet', 'win', 'yes', 'yet', 'zoo', 'bake', 'ball',
  'band', 'bank', 'bath', 'bear', 'beat', 'bell', 'belt', 'bike', 'bird', 'blue',
  'boat', 'bone', 'born', 'boss', 'bowl', 'busy', 'cake', 'calm', 'camp', 'card',
  'care', 'case', 'cash', 'cave', 'cell', 'chat', 'chin', 'clap', 'club', 'coat',
  'code', 'cold', 'cook', 'cool', 'copy', 'corn', 'cost', 'crew', 'crop', 'dark',
  'data', 'date', 'deal', 'dear', 'deep', 'desk', 'dish', 'draw', 'drop', 'drum',
  'duck', 'dust', 'duty', 'easy', 'edge', 'else', 'fact', 'fair', 'fall', 'farm',
  'fast', 'fear', 'feel', 'fill', 'film', 'fine', 'fire', 'fish', 'flag', 'flat',
  'flow', 'folk', 'foot', 'fork', 'fuel', 'full', 'gain', 'game', 'gate', 'gift',
  'glad', 'glow', 'goal', 'gold', 'golf', 'gray', 'grow', 'hair', 'half', 'hall',
  'hang', 'hear', 'heat', 'hill', 'hold', 'hole', 'huge', 'hunt', 'inch', 'iron',
  'jazz', 'join', 'joke', 'jump', 'keen', 'kick', 'king', 'kite', 'lake', 'lamp',
  'lane', 'late', 'lawn', 'lazy', 'lead', 'leaf', 'lend', 'less', 'lift', 'list',
  'load', 'loan', 'lock', 'loud', 'love', 'luck', 'lunch', 'mail', 'main', 'mall',
  'meal', 'meat', 'mild', 'milk', 'mind', 'mint', 'miss', 'mood', 'moon', 'nest',
  'neat', 'news', 'nice', 'nine', 'note', 'oven', 'pack', 'page', 'pain', 'pair',
  'park', 'pass', 'path', 'peak', 'pick', 'pile', 'pink', 'plan', 'plus', 'pool',
  'poor', 'pour', 'pull', 'push', 'quiz', 'race', 'rain', 'rank', 'rare', 'rest',
  'rice', 'rich', 'ride', 'ring', 'rise', 'road', 'rock', 'roof', 'rope', 'rose',
  'rule', 'rush', 'safe', 'sail', 'salt', 'sand', 'save', 'seat', 'seed', 'sell',
  'send', 'ship', 'shoe', 'shop', 'sign', 'silk', 'sing', 'sink', 'size', 'skip',
  'slow', 'snow', 'soap', 'sock', 'soft', 'soil', 'song', 'soon', 'sort', 'soup',
  'spot', 'star', 'stay', 'step', 'swim', 'tail', 'tall', 'tank', 'tape', 'team',
  'tent', 'test', 'text', 'tide', 'tile', 'tiny', 'tool', 'tour', 'town', 'tree',
  'trip', 'tune', 'unit', 'vast', 'view', 'vote', 'wait', 'wake', 'wall', 'warm',
  'wash', 'wave', 'wear', 'week', 'west', 'wide', 'wild', 'wind', 'wise', 'wish',
  'wood', 'yard', 'yell', 'zero', 'zone', 'above', 'actor', 'adult', 'agree', 'alarm',
  'alive', 'apple', 'award', 'basic', 'beach', 'bench', 'berry', 'black', 'blend', 'block',
  'board', 'brain', 'brave', 'bread', 'brief', 'broad', 'brown', 'brush', 'build', 'cabin',
  'candy', 'chair', 'chalk', 'cheap', 'check', 'chess', 'chief', 'civil', 'clean', 'clear',
  'climb', 'clock', 'cloud', 'coast', 'couch', 'count', 'cover', 'craft', 'cream', 'crowd',
  'dance', 'delay', 'dream', 'dress', 'drink', 'drive', 'eager', 'equal', 'event', 'exact',
  'extra', 'fancy', 'field', 'final', 'flame', 'float', 'floor', 'focus', 'fresh', 'front',
  'fruit', 'funny', 'glass', 'grade', 'grand', 'grape', 'grass', 'green', 'guess', 'guide',
  'happy', 'heavy', 'hobby', 'honey', 'horse', 'hotel', 'human', 'judge', 'juice', 'knife',
  'laugh', 'layer', 'lemon', 'level', 'lucky', 'magic', 'major', 'maple', 'match', 'metal',
  'minor', 'model', 'money', 'month', 'motor', 'mouse', 'mouth', 'movie', 'noise', 'north',
  'ocean', 'offer', 'olive', 'onion', 'paint', 'panel', 'party', 'peace', 'phone', 'photo',
  'piano', 'piece', 'pilot', 'plain', 'plate', 'price', 'proud', 'quick', 'quiet', 'radio',
  'raise', 'range', 'reach', 'ready', 'river', 'robot', 'round', 'route', 'royal', 'salad',
  'scale', 'score', 'shape', 'share', 'sharp', 'sheep', 'shelf', 'shell', 'shine', 'shirt',
  'short', 'skill', 'sleep', 'slice', 'smile', 'smoke', 'snack', 'solid', 'south', 'space',
  'spare', 'speak', 'speed', 'spend', 'spoon', 'sport', 'staff', 'stage', 'stamp', 'steam',
  'stone', 'storm', 'stove', 'sugar', 'sunny', 'sweet', 'taste', 'teach', 'thank', 'thick',
  'thumb', 'tiger', 'toast', 'topic', 'total', 'touch', 'tower', 'track', 'trail', 'train',
  'treat', 'trust', 'truth', 'uncle', 'upper', 'usual', 'value', 'video', 'visit', 'voice',
  'wheel', 'where', 'woman', 'worry'
];

// Shuffle an array in place using Fisher-Yates
function shuffle<T>(arr: T[]): T[] {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

// Generate random words for practice test
export function generateRandomWords(count: number): string {
  const filteredBank = SIMPLE_WORD_BANK.filter(w => w.length > 1);
  const words: string[] = [];
  // Fill with shuffled passes through the word bank to avoid long runs of repeats
  while (words.length < count) {
    const shuffled = shuffle(filteredBank);
    words.push(...shuffled);
  }
  return words.slice(0, count).join(' ');
}

// Generate enough words for a specific duration (buffer at 250 WPM)
export function generateWordsForDuration(seconds: number): string {
  const wordsNeeded = Math.ceil((seconds / 60) * 250);
  return generateRandomWords(wordsNeeded);
}
